import { useSelector } from "react-redux"
import { selectExpert } from "./expertSlice"

export const useExpert = () => {
  const { body, updating } = useSelector(selectExpert)

  return {
    body,
    updating
  }
}